/* eslint-disable @typescript-eslint/no-explicit-any */
import { deviceUtil } from "@repo/lib-common";
import { Bidder } from "./bidder";
import { NamedSize_Val1, NamedSize_Val2, SingleSizeArray } from "./googleTypes";
/** bidder helper class for easy use cases
 *
 * */
export class BidderHelper {
    bidders = new Array<Bidder>();
    addBidder(bidder: Bidder) {
        this.bidders.push(bidder);
    }
    addBidders(bidders: Array<Bidder>) {
        this.bidders.push(...bidders);
    }

    // filterBySizeArray(sizeArray: SingleSizeArray) {

    //     const filteredBidders = new Array<Bidder>();
    //     for (let i = 0; i < sizeArray.length; i++) {
    //         const size = sizeArray[i];
    //         // @ts-expect-error named obj
    //         if (!Array.isArray(size) || size === NamedSize_Val1 || size === NamedSize_Val2) continue;
    //         const tBidders = this.bidders.filter(b => b.isEnabled && (b.isAnySizeAllowed ||
    //             b.allowedSizes.filter((value) => value[0] === size[0] && value[1] === size[1]).length > 0)
    //         );
    //         filteredBidders.push(...tBidders);
    //     }

    //     return filteredBidders;
    // }

    filterBySizeAndDevice(sizeArray: SingleSizeArray, deviceTypes: Array<deviceUtil.DeviceTypeEnum>) {

        const filteredBidders = new Array<Bidder>();
        for (let i = 0; i < sizeArray.length; i++) {
            const size = sizeArray[i];
            // @ts-expect-error named obj
            if (!Array.isArray(size) || size === NamedSize_Val1 || size === NamedSize_Val2) continue;
            const tBidders = this.bidders.filter(b => b.isEnabled &&
                (b.isAnyDeviceAllowed === true || b.allowedDevices.filter(d => deviceTypes.includes(d)).length > 0)
                && (b.isAnySizeAllowed === true ||
                    b.allowedSizes.filter((value) => value[0] === size[0] && value[1] === size[1]).length > 0)
            );
            filteredBidders.push(...tBidders);
        }

        return filteredBidders;
    }



}


